module.exports = __webpack_public_path__ + "img/al.244afce9.svg";